import React, { useEffect } from 'react';
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";


type modalSize = "sm" | "lg" | "xl"
function ModalContainer({ show, setShow, title, children, size, closeEvent, className, backdrop, closeBtn, centered }:
    { show: boolean, setShow: any, title: React.ReactNode, children: React.ReactNode, size: modalSize, closeEvent: any, className: string, backdrop: boolean, closeBtn: boolean, centered?: boolean }) {
    function handleClose() {
        setShow(false)
        if (closeEvent) {
            closeEvent()
        }
    }

    useEffect(() => {
        if (show)
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = '0';
    }, [show])
    return (
        <Modal show={show}
            onHide={handleClose}
            size={size}
            centered={centered}
            backdrop={backdrop}
            preventScroll={false}
            scrollable
            className={`page-modal ${className}`}
        >

            <Modal.Body>
                {title ? <Modal.Header className={"modal-title"}>{title}</Modal.Header> : <></>}
                {
                    closeBtn
                        ? <span className={'modal-close-btn'}
                            onClick={handleClose}>
                            <FontAwesomeIcon icon={faXmark} />
                        </span>
                        : <></>
                }
                {children}
            </Modal.Body>
        </Modal>
    )
}
ModalContainer.defaultProps = {
    title: "",
    size: "md",
    closeEvent: undefined,
    className: "",
    backdrop: true,
    closeBtn: false,
    centered: false
}

export default ModalContainer;